import React from 'react';
import { FormName } from 'redux-form';

import { SnapcodesFormContainer } from './form/SnapcodesFormContainer';
import { SnapcodesProps } from './Snapcodes.types';

export const Snapcodes = (props: SnapcodesProps) => {
  const { snapchat } = props;

  if (snapchat) {
    return <FormName>{({ form }) => <SnapcodesFormContainer form={form} />}</FormName>;
  }

  return null;
};
